import {Network} from '../../../utils/network';
import {socialClubActionTypes} from './club.actionTypes';

export const getClubEventDetails = req => async (dispatch, state) => {
  try {
    dispatch({
      type: socialClubActionTypes.SET_CLUB_EVENT_DATA_LOAD,
    });
    const res = await Network.getClubEventDetails(req);
    if (res.data) {
      dispatch({
        type: socialClubActionTypes.SET_CLUB_EVENT_DATA,
        payload: res.data,
      });
    }
  } catch (e) {
    dispatch({
      type: socialClubActionTypes.SET_CLUB_EVENT_DATA_FAIL,
      payload: e.response,
    });
  }
};

export const getClubList = req => async (dispatch, state) => {
  try {
    dispatch({
      type: socialClubActionTypes.SET_CLUB_LIST_REQUEST,
    });
    const res = await Network.getClubs();
    if (res.data) {
      dispatch({
        type: socialClubActionTypes.SET_CLUB_LIST,
        payload: res.data,
      });
    }
  } catch (e) {
    dispatch({
      type: socialClubActionTypes.SET_CLUB_LIST_FAIL,
      payload: e.response,
    });
  }
};
export const getClubListLive = id => async (dispatch, state) => {
  try {
    dispatch({
      type: socialClubActionTypes.SET_CLUB_LIVE_DATA_REQUEST,
    });
    const res = await Network.fetchClubLive(id);
    if (res.data) {
      dispatch({
        type: socialClubActionTypes.SET_CLUB_LIVE_DATA,
        payload: res.data,
      });
    }
  } catch (e) {
    dispatch({
      type: socialClubActionTypes.SET_CLUB_LIVE_DATA_FAIL,
      payload: e.response,
    });
  }
};
export const getClubListClosed = id => async (dispatch, state) => {
  try {
    dispatch({
      type: socialClubActionTypes.SET_CLUB_CLOSED_DATA_REQUEST,
    });
    const res = await Network.fetchClubClosed(id);
    if (res.data) {
      dispatch({
        type: socialClubActionTypes.SET_CLUB_CLOSED_DATA,
        payload: res.data,
      });
    }
  } catch (e) {
    dispatch({
      type: socialClubActionTypes.SET_CLUB_CLOSED_DATA_FAIL,
      payload: e.response,
    });
  }
};

export const fetchClubMarkets = id => async (dispatch, state) => {
  try {
    dispatch({
      type: socialClubActionTypes.FETCH_CLUB_MARKET_REQUEST,
      payload: null,
    });
    const res = await Network.fetchClubMarkets(id);
    if (res.data) {
      dispatch({
        type: socialClubActionTypes.FETCH_CLUB_MARKET_SUCCESS,
        payload: res.data,
      });
    }
  } catch (e) {
    dispatch({
      type: socialClubActionTypes.FETCH_CLUB_MARKET_ERROR,
      payload: e.response,
    });
  }
};
